import { put, select, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { IUnallocatedProduct, unallocatedProductsActionCreators } from '..';
import { IState } from '../..';
import { httpService } from '../../..';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialog } from '../../sagaUtils';

function* fetchUnallocatedProductsSaga(action: ReturnType<typeof unallocatedProductsActionCreators.fetch>) {
  const isLoaded: boolean = yield select((state: IState) => state.unallocatedProducts.isLoaded);

  if (!isLoaded || action.payload.partialUpdateId || action.payload.full) {
    if (!isLoaded) {
      yield put(unallocatedProductsActionCreators.toggleLoading());
    }
    const response = yield* call(fetchUnallocatedProducts, action.payload.partialUpdateId);

    if (response.requestFailed) {
      yield showFailedRequestDialog(response);
    } else if (response.value) {
      yield put(unallocatedProductsActionCreators.set(response.value));
      if (!isLoaded && !action.payload.partialUpdateId) {
        yield put(unallocatedProductsActionCreators.setLoaded());
      }
    }

    if (!isLoaded) {
      yield put(unallocatedProductsActionCreators.toggleLoading());
    }
  }
}

export function* watchFetchUnallocatedProducts() {
  yield takeEvery(unallocatedProductsActionCreators.fetch.match, fetchUnallocatedProductsSaga);
}

export async function fetchUnallocatedProducts(partialUpdateId?: string) {
  return executeApiRequest<IUnallocatedProduct[]>(() => httpService.get(ApiUrls.unallocatedProducts(partialUpdateId)));
}
